module.exports = __webpack_public_path__ + "media/images/logo/Logo(H)_Grey-d34a6158e0812206e9446d587e64467f.png";